import { gql } from "@apollo/client";

export const SUBSCRIPTION_GET_USER_TO_PROCESS_HISTORY = gql`
  subscription SUBSCRIPTION_GET_USER_TO_PROCESS_HISTORY(
    $patientId: uuid, 
    $processId: Int,
    $initialDate: timestamptz, 
    $finalDate: timestamptz, 
  ) {
    userToProcessHistory(where: {created_at: {_gte: $initialDate, _lte: $finalDate}, userToProcess: {userId: {_eq: $patientId}}, processId: {_eq: $processId}}, order_by: {created_at: desc}) {
      id
      processId
      stageId
      doctorId
      descript
      created_at
      userToProcessId
      latestCustomFormId
      customFormFieldChanges
      processStage {
        id
        stageName
      }
      doctor {
        name
        lastname
        picture
        gender
      }
    }
  }
`

export const SUBSCRIPTION_GET_USER_TO_PROCESS_HISTORY_AND_CALL_NOTE = gql`
  subscription QUERY_GET_USER_TO_PROCESS_HISTORY_AND_CALL_NOTE {
    call(order_by: {date: desc}, limit: 1) {
      id
      duration
      startTime
      endTime
      date
    }
  }
`

export const SUBSCRIPTION_GET_USER_TO_PROCESS_HISTORY_BY_PATIENT = gql`
  subscription SUBSCRIPTION_GET_USER_TO_PROCESS_HISTORY_BY_PATIENT(
    $patientId: uuid!
  ) {
    userToProcessHistory(where: {
      userToProcess: {
        userId: {
          _eq: $patientId
        }
      }, 
    }
    order_by: {
      created_at: desc
    }
  ) {
      id
      processId
      stageId
      doctorId
      descript
      created_at
      userToProcessId
      latestCustomFormId
      customFormFieldChanges
      callId
      call {
        id
        status
        date
        duration
        startTime
        endTime
        phoneNumber
        transcription
        callCost
        transcriptionCost
        doctorId
        userId
        userToProcessId
      }
      userToProcess {
        descript
        id
        created_at
        isAcepted
        process {
          descript
          nameKey
          processName
        }
      }
      doctor {
        name
        lastname
        picture
        gender
      }
    }
  }
`